import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useMemo } from "react";
var mapProductMessageByViewport = function(banner, viewport) {
    switch(true){
        case viewport.isDesktopAndAbove:
            if (banner.desktop_and_above) {
                return banner.desktop_and_above;
            }
            if (banner.tablet_and_above) {
                return banner.tablet_and_above;
            }
            return banner.mobile_and_above;
        case viewport.isTabletAndAbove:
            if (banner.tablet_and_above) {
                return banner.tablet_and_above;
            }
            return banner.mobile_and_above;
        default:
            return banner.mobile_and_above;
    }
};
export var useGetBannerContentByViewport = function(banners) {
    var viewport = useViewport();
    var bannerContents = useMemo(function() {
        return banners.map(function(banner) {
            return mapProductMessageByViewport(banner, viewport);
        }).filter(isNotUndefined);
    }, [
        banners,
        viewport
    ]);
    var bannerNames = useMemo(function() {
        return bannerContents.map(function(banner) {
            var _banner_campaign_name;
            return (_banner_campaign_name = banner === null || banner === void 0 ? void 0 : banner.campaign_name) !== null && _banner_campaign_name !== void 0 ? _banner_campaign_name : "";
        });
    }, [
        bannerContents
    ]);
    return {
        bannerContents: bannerContents,
        bannerNames: bannerNames
    };
};
